// ProfileButton.js

import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../context/authContext';

const SellTicketButton = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <Link
      to={isAuthenticated ? "/sellTicket" : "/register"}
      className="flex items-center justify-center lg:w-32 md:w-20 h-8 lg:text-lg md:text-sm rounded-md uppercase font-heading md:pt-0.5 bg-wild-ocean text-white "
    >
      {isAuthenticated ? t('buttons.sell') : t('buttons.register')}
    </Link>
  );
};

export default SellTicketButton;
